import { get } from "lodash"
import { createSelector } from "reselect"

const getAccountStatus = state => get(state, "global.selected.accountMeta.status")
const getIsSuperuser = state => get(state, "user.isSuperuser", false)
export const getIsSuperuserSession = createSelector(
  [getIsSuperuser, getAccountStatus],
  (isSuperuser, accountStatus) => isSuperuser && accountStatus !== "internal")
const getSolutionsCount = state => get(state, "global.data.solutionsCount.data.count")
export const getHasSolutions = createSelector([getSolutionsCount], (count) => count > 0)
